export default __webpack_public_path__ + "static/media/chevron-left.19918a16.svg";